import { PureComponent } from 'react'
import XAxisTick from '../../../Common/NewDashboard/Chart/XAxisTick/XAxisTick'
import {
  DATE_FORMAT,
  getMomentDateTimeFromApiData
} from '../../../../lib/MomentHelper'

const TICK_DATE_FORMAT = `${DATE_FORMAT.LINE_CHART_X_AXIS_DATE}`

class CustomizeXAxisTick extends PureComponent {
  render () {
    const { x, y, payload } = this.props
    const tickDate = getMomentDateTimeFromApiData(payload.value).format(
      TICK_DATE_FORMAT
    )
    return (
      <XAxisTick svgProps={{ x, y }}>
        <tspan
          x={0}
          dy={12}
        >
          {tickDate}
        </tspan>
      </XAxisTick>
    )
  }
}

export default CustomizeXAxisTick
